import * as React from "react";
import Topup from "./topup/Topup";
import Login from "./auth/Login";
import Receipt from "./myaccount/Receipt";
import { Paypal } from "./topup/Paypal";
import Home from "./myaccount/Home";
import OrderHistory from "./myaccount/OrderHistory";
import Register from "./auth/Register";
import Verify from "./auth/Verify";
import { AutoTopups } from "./myaccount/AutoTopups";
import { SupportTickets } from "./myaccount/SupportTickets";
import SupportTicketNew from "./myaccount/SupportTicketNew";
import SupportTicketEdit from "./myaccount/SupportTicketEdit";
import { ContactList } from "./myaccount/ContactList";
import RewardPoints from "./myaccount/RewardPoints";
import ForgotPassword from "./auth/FogrotPassword";
import AutoTopup from "./myaccount/AutoTopup";
import TrxTimeout from "./myaccount/TrxTimeout";
// import { withQuery, withSessionId, withAnalytics, withQueryAndAnalytics, withinFlex } from "./Decorators";
import Contact from "./myaccount/Contact";
import t from "./i18n";
import { LocationWithQuery, Props } from "../types/global";
import qs from "qs";
import { createHashHistory } from "history";
import { GTMDataLayer } from "./services/gtm-datalayer";
import { Redirect } from "react-router-dom";
import { uuidv4 } from "./utils";
import ChangePassword from "./auth/ChangePassword";
import ManagePayment from "./myaccount/ManagePayments";
import StoredCardsList from "./myaccount/StoredCardsList";
//import GiftCard from "./giftcard/GiftCard";
import GiftCard from "./topup/GiftCard";

declare type ReactComponent = React.ComponentClass<any, React.ComponentState> | React.FC<any>;
export const history = createHashHistory();
export declare type RoutesType = {
    TOPUP: { path: string, component: ReactComponent, title: string },
    LOGIN: { path: string, component: ReactComponent, title: string },
    CHANGE_PASSWORD: { path: string, component: ReactComponent, title: string },
    REGISTER: { path: string, component: ReactComponent, title: string },
    VERIFY: { path: string, component: ReactComponent, title: string },
    FORGOT_PASSWORD: { path: string, component: ReactComponent, title: string },
    RECEIPT: { path: string, component: ReactComponent, title: string },
    PAYPAL: { path: string, component: ReactComponent, title: string },
    HOME: { path: string, component: ReactComponent, title: string },
    INDEX: { path: string, component: ReactComponent, title: string },
    ORDER_HISTORY: { path: string, component: ReactComponent, title: string },
    AUTO_TOPUP: { path: string, component: ReactComponent, title: string },
    AUTO_TOPUPS: { path: string, component: ReactComponent, title: string },
    SUPPORT_TICKETS: { path: string, component: ReactComponent, title: string },
    SUPPORT_TICKETS_NEW: { path: string, component: ReactComponent, title: string },
    SUPPORT_TICKETS_EDIT: { path: string, component: ReactComponent, title: string },
    CONTACT_LIST: { path: string, component: ReactComponent, title: string },
    CONTACT: { path: string, component: ReactComponent, title: string },
    REWARD_POINTS: { path: string, component: ReactComponent, title: string },
    TIME_OUT: { path: string, component: ReactComponent, title: string },
    MANAGE_PAYMENTS: { path: string, component: ReactComponent, title: string },
    STORED_CARDS: { path: string, component: ReactComponent, title: string },
    GIFTCARD: { path: string, component: ReactComponent, title: string }
}
export const ROUTES: RoutesType = {
    TOPUP: { path: '/topup', component: withQuery(withSessionId(withAnalytics(Topup))), title: t.menu("send_balance") },
    INDEX: { path: '/', component: withQuery(withSessionId(withAnalytics(Topup))), title: t.menu("send_balance") },
    LOGIN: { path: '/login', component: withinFlex(withQueryAndAnalytics(Login)), title: t.menu("login") },
    CHANGE_PASSWORD: { path: '/change-password', component: withinFlex(withQueryAndAnalytics(ChangePassword)), title: t.menu("change_password") },
    REGISTER: { path: '/register', component: withinFlex(withQueryAndAnalytics(Register)), title: t.menu("register") },
    VERIFY: { path: '/verify', component: withinFlex(withQueryAndAnalytics(Verify)), title: t.menu("verify_code") },
    FORGOT_PASSWORD: { path: '/forgot-password', component: withinFlex(withQueryAndAnalytics(ForgotPassword)), title: t.menu("forgot_password") },
    RECEIPT: { path: "/receipt", component: withQueryAndAnalytics(Receipt), title: t.menu("receipt") },
    PAYPAL: { path: "/paypal", component: withQueryAndAnalytics(Paypal), title: "Paypal" },
    HOME: { path: "/home", component: withQueryAndAnalytics(Home), title: t.menu("dashboard") },
    ORDER_HISTORY: { path: "/order-history", component: withQueryAndAnalytics(OrderHistory), title: t.menu("order_history") },
    AUTO_TOPUP: { path: "/auto-topup", component: withQueryAndAnalytics(AutoTopup), title: t.menu("auto_balance") },
    AUTO_TOPUPS: { path: "/auto-topups", component: withQueryAndAnalytics(AutoTopups), title: t.menu("auto_balance") },
    SUPPORT_TICKETS: { path: "/tickets", component: withQueryAndAnalytics(SupportTickets), title: t.menu("support_tickets") },
    SUPPORT_TICKETS_NEW: { path: "/ticket/new", component: withQueryAndAnalytics(SupportTicketNew), title: t.myaccount("new_ticket") },
    SUPPORT_TICKETS_EDIT: { path: "/ticket/edit", component: withQueryAndAnalytics(SupportTicketEdit), title: t.myaccount("ticeket_detail") },
    CONTACT_LIST: { path: "/contact-list", component: withQueryAndAnalytics(ContactList), title: t.menu("contact_list") },
    CONTACT: { path: "/contact/:id", component: withQueryAndAnalytics(Contact), title: t.myaccount("new_contact") },
    REWARD_POINTS: { path: "/reward-points", component: withQueryAndAnalytics(RewardPoints), title: t.menu("reward_points") },
    TIME_OUT: { path: "/timeout", component: withQueryAndAnalytics(TrxTimeout), title: t.receipt("topup-timeout") },
    MANAGE_PAYMENTS: { path: "/manage-payments", component: withQueryAndAnalytics(ManagePayment), title: t.menu("manage-payments") },
    STORED_CARDS: { path: "/stored-cards", component: withQueryAndAnalytics(StoredCardsList), title: t.menu("stored-cards") },
    GIFTCARD: { path: "/giftcard", component: withQuery(withSessionId(withAnalytics(GiftCard))), title: t.menu("buy_gift_card") }
};
declare type RouteKeyType = keyof typeof ROUTES;
// tslint:disable-next-line:no-unused-expression
export function getTitleByPathName(pathName: string): string {
    for (const key in ROUTES) {
        if (ROUTES[key as RouteKeyType].path === pathName) return ROUTES[key as RouteKeyType].title;
    }
    return "";
}
export const routeMap = (() => {
    return Object.keys(ROUTES).map(k => ROUTES[k as RouteKeyType]) as Array<{ path: string, component: any }>
})();

function shallowDiffers(a: any, b: any) {
    for (const i in a) if (!(i in b)) return true
    // tslint:disable-next-line:triple-equals
    for (const i in b) if (a[i] != b[i]) return true
    // console.log(a, b, false);
    return false
}
function getRoute(this: LocationWithQuery<any>, query: object) {
    //if (!shallowDiffers(location.query, query)) return;
    return `${this.pathname}?${qs.stringify(query)}`;
}
function push(this: LocationWithQuery<any>, query: object) {
    if (!shallowDiffers(this.query, query)) return;
    history.push(`${this.pathname}?${qs.stringify(query)}`);
}
function replace(this: LocationWithQuery<any>, query: object) {
    if (!shallowDiffers(this.query, query)) return;
    history.replace(`${this.pathname}?${qs.stringify(query)}`);
}
export function withQueryAndAnalytics(Component: React.ComponentClass<any, React.ComponentState> |
    React.FC<any>): React.FC<any> {
    if (!Component) {
        throw new Error("Component must be defined;")
    }
    return withQuery(withAnalytics(Component));
}
export function withQuery(Component: any): React.FC {
    if (!Component) {
        throw new Error("Component must be defined;")
    }
    return function ComponentWithContext(props: any) {
        let newProps = props;
        if ("location" in newProps) {
            const queryString = newProps.location.search ? newProps.location.search.replace("?", "") : ""
            newProps.location.query = qs.parse(queryString);
            newProps.location.push = push;
            newProps.location.replace = replace;
            newProps.location.getRoute = getRoute;
        } else {
            newProps = { ...props, location: { query: {} } };
        }
        return <Component {...newProps} />
    }
}
export function withAnalytics(Component: any): any {
    if (!Component) {
        throw new Error("Component must be defined;")
    }
    return class extends React.Component<Props> {
        oldTitle: string;
        componentDidMount() {
            this.oldTitle = document.title;
            const title = getTitleByPathName(this.props.location.pathname);
            if (title) document.title = title;
            // console.log("fire analytics on mount", `pathName:`, this.props.location.pathname, 'step:', this.props.location.query.step);
            GTMDataLayer.firePageView(this.props.location.pathname, this.props.location.query.step);
        }
        componentWillUnmount() {
            if (this.oldTitle) document.title = this.oldTitle;
        }
        componentWillReceiveProps(nextProps: Props) {
            const props = this.props;
            switch (nextProps.location.pathname) {
                case "/topup":
                    const newStep = nextProps.location.query.step || "number";
                    const oldStep = props.location.query.step || "number";
                    if (newStep !== oldStep) {
                        console.log("fire analytics on prop change", nextProps.location.pathname, newStep);
                        GTMDataLayer.firePageView(nextProps.location.pathname, newStep);
                    }
                    break;
                case "/receipt":
                    const newTrxId = nextProps.location.query.transactionId || "number";
                    const oldTrxId = props.location.query.transactionId || "number";
                    if (newTrxId !== oldTrxId) {
                        console.log("fire analytics on prop change", nextProps.location.pathname);
                        GTMDataLayer.firePageView(nextProps.location.pathname);
                    }
                    break;
                case "/giftcard":
                    const newGcStep = nextProps.location.query.step || "order";
                    const oldGcStep = props.location.query.step || "order";
                    if (newGcStep !== oldGcStep) {
                        console.log("fire analytics on prop change", nextProps.location.pathname, newGcStep);
                        GTMDataLayer.firePageView(nextProps.location.pathname, newGcStep);
                    }
                    break;
                default:
                    break;
            }
        }
        render() {
            return <Component {...this.props} />;
        }
    }
}
export function withSessionId(Component: React.FC): React.FC {
    return function ComonentWithSessionId(props: any) {
        const sid = props.location.query ? (props.location.query.sid || "") : "";
        if (sid.length !== 36) {
            return <Redirect to={props.location.getRoute({ ...props.location.query, sid: uuidv4(), step: "number" })} />
        }
        return <Component key={sid} {...props} />
    }
}
export function withinFlex(Component: React.FC): React.FC {
    return function ComponentWithinFlex(props: any) {
        return (
            <div className="d-flex align-items-center" style={{ minHeight: "calc(100vh - 63px)" }}>
                <Component {...props} />
            </div>
        );
    }
}
